<template>
  <div>
    <!-- <Header /> -->
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="QuizDeleted(titlepass)"
    />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindowquestiondelete != null"
      :title="titlepass"
      @cancelClick="popupwindowquestiondelete = null"
      @confirmClick="removeQuestion(popupwindowquestiondelete)"
    />
    <div class="flex">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col h-full" v-if="this.is_selected == 'list'">
          <div
            class="flex flex-wrap gap-4 items-center justify-between px-5 lg:px-10 pt-10"
          >
            <div>
              <h1 class="text-lg font-semibold">Assessment</h1>
            </div>
            <div class="flex gap-3">
              <router-link
                :to="{ name: 'AssessmentOverallFeedback' }"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl hover:bg-blue-700 transition duration-300 ease-in-out"
              >
                Feedback
              </router-link>
              <button
                @click="this.addQuiz = true"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl hover:bg-blue-700 transition duration-300 ease-in-out"
              >
                Add Assessment
              </button>
            </div>
          </div>

          <div class="flex items-center gap-5 px-5 lg:px-10 pt-6 pb-3">
            <button
              @click="
                (typeQuiz = 'course'), quizgetinfo();
                this.active_tab = 'Course Quiz';
              "
              :class="
                this.active_tab == 'Course Quiz'
                  ? 'bg-blues text-white'
                  : 'text-black bg-gray-100 hover:bg-slate-300'
              "
              class="font-semibold text-xs px-4 py-2 rounded-xl"
            >
              Course Quiz
            </button>
            <button
              @click="
                (typeQuiz = 'lesson'), quizgetinfo();
                this.active_tab = 'Lesson Quiz';
              "
              :class="
                this.active_tab == 'Lesson Quiz'
                  ? 'bg-blues text-white'
                  : 'text-black bg-gray-100  hover:bg-slate-300'
              "
              class="font-semibold text-xs px-4 py-2 rounded-xl"
            >
              Lesson Quiz
            </button>
          </div>

          <div v-if="loading" class="flex flex-col justify-center h-screen">
            <div class="flex justify-center">
              <img src="@/assets/newd/loading.gif" alt="" />
            </div>
          </div>

          <div
            v-else-if="(this.generalquiz.length > 0) & !loading"
            class="flex flex-col gap-10 px-5 lg:px-10 pt-5 pb-10 w-full"
          >
            <!-- Dynamic Title Section -->
            <div class="flex items-center justify-between w-full border-b pb-3">
              <h1 class="text-md lg:text-xl font-bold text-gray-800">
                {{
                  active_tab === "Course Quiz" ? "Course Quiz" : "Lesson Quiz"
                }}
              </h1>
              <p class="text-gray-600 text-base font-medium">
                Total:
                <span class="text-blue-600 font-semibold">{{
                  generalquiz.length
                }}</span>
              </p>
            </div>

            <!-- <pre>{{ generalquiz }}</pre> -->
            <draggable
              v-model="generalquiz"
              item-key="quiz.quiz.id"
              class="dragArea list-group w-full"
              @change="handleQuizOrderChange"
              :animation="200"
              handle=".drag-handle-quiz"
              ghost-class="ghost"
              chosen-class="chosen"
              :force-fallback="true"
              :scroll-sensitivity="80"
              :scroll-speed="2"
              :bubble-scroll="true"
            >
              <transition-group type="transition" class="flip-list">
                <div
                  v-for="(quiz, index) in generalquiz"
                  :key="quiz.quiz.id"
                  class="group p-5 lg:p-10 flex items-center gap-5 lg:gap-10 w-full border rounded-2xl hover:bg-gray-50 transition mb-5 last:mb-0"
                >
                  <div
                    class="flex flex-col gap-2 lg:gap-0 lg:flex-row md:flex-row items-center justify-between w-full"
                  >
                    <div
                      class="flex flex-col md:flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-10 w-full relative"
                    >
                      <div class="relative">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          class="w-6 h-6 text-gray-600 cursor-move drag-handle-quiz"
                          title="Drag to reorder quizzes"
                        >
                          <circle cx="5" cy="5" r="1.5" />
                          <circle cx="12" cy="5" r="1.5" />
                          <circle cx="5" cy="12" r="1.5" />
                          <circle cx="12" cy="12" r="1.5" />
                          <circle cx="5" cy="19" r="1.5" />
                          <circle cx="12" cy="19" r="1.5" />
                        </svg>
                      </div>

                      <!-- Quiz Icon -->
                      <div class="flex items-center gap-3 w-full md:w-auto">
                        <img
                          src="@/assets/new/assignment.png"
                          class="rounded-xl w-full sm:w-1/2 md:w-1/3 lg:w-auto"
                          alt="quiz"
                        />
                      </div>

                      <!-- Quiz Details -->
                      <div class="flex flex-col gap-2 w-full">
                        <!-- Quiz Name Edit Section -->
                        <div
                          v-if="editQuizId !== quiz.quiz.id"
                          class="flex gap-3 items-center"
                        >
                          <h1 class="text-gray-700 text-base font-bold">
                            {{ quiz.quiz.name }}
                          </h1>
                          <img
                            @click="editId(quiz.quiz.id)"
                            src="@/assets/edit.svg"
                            alt="edit"
                            class="object-contain w-5 h-5 sm:w-6 sm:h-6 cursor-pointer flex-shrink-0"
                          />
                        </div>

                        <!-- Edit Quiz Name Form -->
                        <form
                          v-if="editQuizId == quiz.quiz.id"
                          @submit.prevent="PostData(quiz.quiz.id)"
                          class="flex flex-wrap items-center gap-3"
                        >
                          <input
                            v-if="quizdetailsget.lesson_quize == false"
                            class="border px-3 py-1"
                            type="text"
                            v-model="quizdetailsget.name"
                            required
                            autofocus
                          />
                          <input v-else
                            class="border px-3 py-1"
                            type="text"
                            v-model="quizdetailsget.lesson_title"
                            required
                            autofocus
                          />
                          <div class="flex items-center gap-3">
                            <button
                              type="submit"
                              :disabled="disable_submit == true"
                              :class="
                                this.disable_submit == true
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              "
                            >
                              <img
                                src="@/assets/tick.png"
                                alt="submit"
                                class="object-contain w-6 h-6 cursor-pointer"
                              />
                            </button>
                            <img
                              v-if="disable_submit"
                              src="@/assets/loading.gif"
                              alt="loading"
                              class="w-6 h-6 object-contain"
                            />
                          </div>
                          <button type="button" @click="this.editQuizId = null">
                            <img
                              src="@/assets/close.png"
                              alt="close"
                              class="object-contain w-6 h-6 cursor-pointer"
                            />
                          </button>
                        </form>

                        <!-- Question Count -->
                        <h3
                          class="text-left text-sm px-1 py-1 text-blue-600 font-medium"
                        >
                          {{ quiz.quiz.coursequizquestion_set.length }}
                          Questions
                        </h3>

                        <!-- Quiz Attempt Display -->
                        <div
                          class="flex flex-col gap-1.5"
                          v-if="editAttempt !== quiz.quiz.id"
                        >
                          <p v-if="quiz.quiz.question_attempt" class="text-sm">
                            Multiple Attempt Quiz
                          </p>
                          <p v-if="quiz.quiz.question_attempt" class="text-sm">
                            <b class="font-bold text-blue-600">{{
                              quiz.quiz.question_attempt_count
                            }}</b>
                            Quiz Attempt
                          </p>
                          <div class="flex">
                            <div
                              class="flex items-center gap-2 text-sm py-1 px-3 border text-center justify-center cursor-pointer text-green-800 border-green-800 rounded-xl hover:bg-green-50"
                              @click="editIdAttempt(quiz.quiz.id)"
                            >
                              <img
                                src="@/assets/edit.svg"
                                alt="edit"
                                class="object-contain w-4 h-4 cursor-pointer"
                              />
                              Edit Attempt
                            </div>
                          </div>
                        </div>

                        <!-- Quiz Attempt Edit Form -->
                        <form
                          @submit.prevent="PostDataAttempt(quiz.quiz.id)"
                          class="flex flex-col gap-1.5"
                          v-if="editAttempt == quiz.quiz.id"
                        >
                          <h3 class="text-left text-sm px-1 py-1 font-medium">
                            <input
                              type="checkbox"
                              v-model="quizdetailsget.question_attempt"
                            />
                            Quiz Attempt
                          </h3>

                          <div class="flex items-center gap-2">
                            <input
                              v-if="quizdetailsget.question_attempt"
                              v-model="quizdetailsget.question_attempt_count"
                              class="text-sm px-1 py-1 border"
                              type="number"
                            />
                          </div>

                          <div class="flex items-center gap-3">
                            <button
                              type="submit"
                              class="bg-blue-600 text-sm text-white px-3 py-1 rounded-lg hover:bg-blue-700"
                            >
                              Update
                            </button>
                            <button
                              type="button"
                              @click="editAttempt = null"
                              class="bg-red-600 text-sm text-white px-3 py-1 rounded-lg hover:bg-red-700"
                            >
                              Cancel
                            </button>
                          </div>
                        </form>

                        <!-- Publish Status -->
                        <div class="flex justify-between items-center w-full">
                          <div v-if="quiz.quiz.qualify_certificate == true">
                            <label
                              class="text-left text-sm px-1 py-1 text-green-700 font-medium cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                @click="
                                  quiz_published(
                                    quiz.quiz.id,
                                    quiz.quiz.name,
                                    false
                                  )
                                "
                                :checked="true"
                              />
                              Published
                            </label>
                          </div>
                          <div v-else>
                            <label
                              class="text-left text-sm px-1 py-1 text-red-700 font-medium cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                @click="
                                  quiz_published(
                                    quiz.quiz.id,
                                    quiz.quiz.name,
                                    true
                                  )
                                "
                                :checked="false"
                              />
                              Unpublished
                            </label>
                          </div>

                          <!-- Mobile Dropdown Menu -->
                          <div
                            @click="addOperation(quiz.quiz.id)"
                            class="cursor-pointer relative dropdown-container md:hidden"
                          >
                            <img
                              src="@/assets/newd/colon.png"
                              class="hover:bg-gray-300 px-2 py-1 rounded"
                              alt="menu"
                            />

                            <div
                              class="flex flex-col gap-3 absolute top-8 right-0 z-[100] bg-white rounded-lg shadow-lg p-5"
                              v-if="popUpAction == quiz.quiz.id"
                              @click.self="popUpAction = null"
                            >
                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizdetailspreview(quiz.quiz.id)"
                              >
                                Preview
                              </button>

                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizdetailsof_details(quiz.quiz.id)"
                              >
                                Edit
                              </button>

                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizdetails(quiz.quiz.id)"
                              >
                                Edit Quiz
                              </button>

                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizgetscoreinfo(quiz.quiz.id)"
                              >
                                Scoreboard
                              </button>

                              <div
                                v-if="
                                  quiz.quiz.is_active &&
                                  quiz.quiz.quiz_feedback.total_count != 0
                                "
                              >
                                <button
                                  class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                  @click="
                                    quizgetscoreinfofeedback(quiz.quiz.id)
                                  "
                                >
                                  Feedbacks
                                </button>
                              </div>

                              <button
                                class="border border-red-400 px-2 rounded flex gap-1 text-sm items-center justify-center py-1 hover:bg-red-100 cursor-pointer text-red-600"
                                @click="
                                  titlepass = quiz.quiz.id;
                                  popupwindow = true;
                                "
                              >
                                <font-awesome-icon
                                  class="text-base text-red-400 self-center h-3 w-3"
                                  :icon="['fas', 'trash-alt']"
                                />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- shuffle Status -->
                        <div
                          class="flex justify-between items-center w-full cursor-pointer"
                        >
                          <div v-if="quiz.quiz.lesson_quize == false">
                            <label
                              class="text-left text-sm px-1 py-1 text-green-700 font-medium cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                @click="
                                  editshuffleContent(
                                    quiz.quiz.id,
                                    quiz.quiz.shuffle
                                  )
                                "
                                v-model="quiz.quiz.shuffle"
                                class="cursor-pointer"
                              />
                              Shuffle
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Desktop Dropdown Menu -->
                    <div
                      @click="addOperation(quiz.quiz.id)"
                      class="cursor-pointer relative dropdown-container hidden md:block"
                    >
                      <img
                        src="@/assets/newd/colon.png"
                        class="hover:bg-gray-300 px-2 py-1 rounded"
                        alt="menu"
                      />

                      <div
                        class="flex flex-col gap-3 absolute top-8 right-0 z-[100] bg-white rounded-lg shadow-lg p-5"
                        v-if="popUpAction == quiz.quiz.id"
                        @click.self="popUpAction = null"
                      >
                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizdetailspreview(quiz.quiz.id)"
                        >
                          Preview
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizdetailsof_details(quiz.quiz.id)"
                        >
                          Edit
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizdetails(quiz.quiz.id)"
                        >
                          Edit Quiz
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="duplicateQuiz(quiz.quiz.id)"
                        >
                          Duplicate
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizgetscoreinfo(quiz.quiz.id)"
                        >
                          Scoreboard
                        </button>

                        <div
                          v-if="
                            quiz.quiz.is_active &&
                            quiz.quiz.quiz_feedback.total_count != 0
                          "
                        >
                          <button
                            class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                            @click="quizgetscoreinfofeedback(quiz.quiz.id)"
                          >
                            Feedbacks
                          </button>
                        </div>

                        <button
                          class="border border-red-400 px-2 rounded flex gap-1 text-sm items-center justify-center py-1 hover:bg-red-100 cursor-pointer text-red-600"
                          @click="
                            titlepass = quiz.quiz.id;
                            popupwindow = true;
                          "
                        >
                          <font-awesome-icon
                            class="text-base text-red-400 self-center h-3 w-3"
                            :icon="['fas', 'trash-alt']"
                          />
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>

          <!-- <div v-else class="h-screen flex flex-col justify-center">
            <div class="flex justify-center">
              <img src="@/assets/newd/loading.gif" alt="" />
            </div>
          </div> -->

          <div
            v-if="this.generalquiz.length == 0 && !loading"
            class="h-screen flex flex-col justify-center p-5 lg:p-10 text-center"
          >
            <p>No Assesments</p>
          </div>
        </div>

        <div class="flex flex-col w-full" v-if="this.is_selected == 'preview'">
          <div class="px-3 lg:px-10 mt-10 pb-2">
            <button
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
              @click="this.is_selected = 'list'"
            >
              Back
            </button>
          </div>

          <form
            ref="addQuizRefs"
            @submit.prevent="updateQuizOfSection(quizdetailsget.id)"
            class="px-3 lg:px-10 mt-5 pb-2"
          >
            <div
              v-for="(form, index) in quizdetailsget.questions"
              :key="index"
              class="w-full mt-3 bg-gray-200 rounded-lg p-4"
            >
              <div class="flex flex-col gap-5">
                <div
                  class="flex items-center justify-between bg-primary px-6 py-3 rounded-t-lg w-full"
                >
                  <label class="text-lg text-white"
                    >Question {{ index + 1 }}:</label
                  >
                </div>

                <div class="px-4 sm:px-6 py-2">
                  <textarea
                    v-model="form.question_text"
                    rows="2"
                    required
                    class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                    placeholder="Enter your question"
                    disabled
                  >
                  </textarea>
                </div>
              </div>

              <div
                class="flex items-center gap-2 px-4 sm:px-6 py-2"
                v-if="quizdetailsget.lesson_quize == true"
              >
                <!-- <input
                  type="radio"
                  value="choice"
                  v-model="form.choice_type"
                  disabled
                />
                Choice Type

                <div>
                  <input
                    type="radio"
                    value="truefalse"
                    v-model="form.choice_type"
                    disabled
                  />
                  True or False
                </div> -->
                <!-- <div>
                  <input
                    type="radio"
                    value="matchthefollowing"
                    v-model="form.choice_type"
                    disabled
                  />
                  Match the following
                </div> -->

                <!-- <input
                  type="radio"
                  value="shortdescription"
                  v-model="form.choice_type"
                  disabled
                />
                Short Answer
                <input
                  type="radio"
                  value="description"
                  v-model="form.choice_type"
                  disabled
                />
                Long Answer -->
              </div>
              <div class="flex items-center gap-2 px-4 sm:px-6 py-2" v-else>
                <input
                  type="radio"
                  value="choice"
                  v-model="form.choice_type"
                  disabled
                />
                Choice Type

                <div>
                  <input
                    type="radio"
                    value="truefalse"
                    v-model="form.choice_type"
                    disabled
                  />
                  True or False
                </div>
                <div>
                  <input
                    type="radio"
                    value="matchthefollowing"
                    v-model="form.choice_type"
                    disabled
                  />
                  Match the following
                </div>

                <input
                  type="radio"
                  value="shortdescription"
                  v-model="form.choice_type"
                  disabled
                />
                Short Answer
                <input
                  type="radio"
                  value="description"
                  v-model="form.choice_type"
                  disabled
                />
                Long Answer
              </div>

              <div
                v-if="form.choice_type == 'choice'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <div
                  v-for="(address, addrIndex) in form.answers"
                  :key="addrIndex"
                  class="flex flex-wrap items-center gap-3 py-2"
                >
                  <label class="text-sm text-gray-700"
                    >Option {{ addrIndex + 1 }}:</label
                  >
                  <input
                    type="text"
                    v-model="address['answer_text']"
                    class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                    placeholder="Enter your option"
                    required
                    disabled
                  />
                  <input
                    type="checkbox"
                    v-model="address['is_correct']"
                    class="w-4 h-4"
                    disabled
                  />
                  <label class="text-sm">Is Answer</label>
                </div>
              </div>

              <div
                v-if="form.choice_type == 'shortdescription'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <input
                  type="number"
                  required
                  v-model="form.max_mark"
                  class="flex-1 border rounded-md p-2 text-sm"
                  placeholder="Add Mark"
                  disabled
                />
              </div>

              <div
                v-if="form.choice_type == 'description'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <input
                  type="number"
                  required
                  v-model="form.max_mark"
                  placeholder="Add Mark"
                  class="flex-1 border rounded-md p-2 text-sm"
                  disabled
                />
              </div>
              <div
                v-if="form.choice_type == 'coding'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <input
                  type="text"
                  disabled
                  v-model="form.programming_language"
                  class="flex-1 border rounded-md p-2 text-sm"
                />
              </div>

              <div
                v-if="form.choice_type == 'matchthefollowing'"
                class="py-3 grid grid-cols-2 gap-2 mt-1 px-6"
              >
                <div>
                  <div
                    v-for="(address, addrIndex) in form.matchthefollowing"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <input
                      type="text"
                      v-model="address.left_text"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Left Option"
                      required
                      disabled
                    />
                  </div>
                </div>
                <div>
                  <div
                    v-for="(address, addrIndex) in form.matchthefollowing"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <input
                      type="text"
                      v-model="address.right_text"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Right Option"
                      required
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div
                v-if="form.choice_type == 'truefalse'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <!-- {{ form.answers }} -->
                <div
                  v-for="(address, addrIndex) in form.truefalse"
                  :key="addrIndex"
                  class="flex flex-wrap items-center gap-3 py-2"
                >
                  <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                  <label class="text-sm text-gray-700"> </label>
                  <!-- <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    /> -->
                  <input
                    type="checkbox"
                    v-model="address['is_correct']"
                    class="w-4 h-4"
                    disabled
                  />
                  <!-- right_text -->
                  <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                  <label class="text-sm"
                    ><span v-if="addrIndex == 0">True</span>
                    <span v-else>False</span></label
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- drag and drop -->
        <div class="flex flex-col w-full" v-if="this.is_selected == 'detail'">
          <div class="px-3 lg:px-10 pt-10 pb-2">
            <button
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
              @click="this.is_selected = 'list'"
            >
              Back
            </button>
          </div>
          <!-- <pre>{{ quizdetailsget }}</pre> -->
          <div>
            <form
              ref="addQuizRefs"
              @submit.prevent="updateQuizOfSection(quizdetailsget.id)"
              class="px-3 lg:px-10 mt-5 pb-2"
            >
              <!-- Fixed draggable configuration -->
              <draggable
                v-model="quizdetailsget.questions"
                item-key="id"
                class="dragArea list-group w-full"
                @change="onReorder"
                :animation="200"
                handle=".drag-handle"
                ghost-class="ghost"
                chosen-class="chosen"
                :force-fallback="true"
                :scroll-sensitivity="80"
                :scroll-speed="2"
                :bubble-scroll="true"
              >
                <transition-group type="transition" class="flip-list">
                  <div
                    v-for="(form, index) in quizdetailsget.questions"
                    :key="form.id || `temp-${index}`"
                    class="w-full mt-3 bg-gray-200 rounded-lg p-4"
                  >
                    <div class="flex flex-col gap-5">
                      <div
                        class="flex items-center justify-between bg-primary px-6 py-3 rounded-t-lg w-full group"
                      >
                        <div class="flex items-center gap-2">
                          <!-- Drag handle with better visibility -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            class="w-5 h-5 text-white cursor-move drag-handle"
                            title="Drag to reorder"
                          >
                            <circle cx="5" cy="5" r="1.5" />
                            <circle cx="12" cy="5" r="1.5" />
                            <circle cx="5" cy="12" r="1.5" />
                            <circle cx="12" cy="12" r="1.5" />
                            <circle cx="5" cy="19" r="1.5" />
                            <circle cx="12" cy="19" r="1.5" />
                          </svg>
                          <label class="text-lg text-white"
                            >Question {{ index + 1 }}
                          </label>
                        </div>

                        <button
                          v-if="form.id"
                          type="button"
                          class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                          @click="
                            (popupwindowquestiondelete = form.id),
                              (titlepass = form.question_text)
                          "
                        >
                          Remove Question
                        </button>

                        <button
                          v-else
                          type="button"
                          class="bg-red-700 text-xs text-white rounded-md px-3 py-1"
                          @click="removeFormUpdate(index)"
                        >
                          Remove Question
                        </button>
                      </div>

                      <div class="px-4 sm:px-6 py-2">
                        <textarea
                          v-model="form.question_text"
                          rows="2"
                          required
                          class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                          placeholder="Enter your question"
                        >
                        </textarea>
                      </div>
                    </div>

                    <!-- Question Type Selection -->
                    <div
                      class="flex items-center gap-2 px-4 sm:px-6 py-2"
                      v-if="quizdetailsget.lesson_quize == true"
                    >
                      <!-- Limited options for lesson quiz -->
                    </div>

                    <div
                      class="flex items-center gap-2 px-4 sm:px-6 py-2"
                      v-else
                    >
                      <input
                        type="radio"
                        value="choice"
                        v-model="form.choice_type"
                      />
                      Choice Type

                      <div>
                        <input
                          type="radio"
                          value="truefalse"
                          v-model="form.choice_type"
                        />
                        True or False
                      </div>
                      <div>
                        <input
                          type="radio"
                          value="matchthefollowing"
                          v-model="form.choice_type"
                        />
                        Match the following
                      </div>

                      <input
                        type="radio"
                        value="shortdescription"
                        v-model="form.choice_type"
                      />
                      Short Answer
                      <input
                        type="radio"
                        value="description"
                        v-model="form.choice_type"
                      />
                      Long Answer
                    </div>

                    <!-- Choice Type -->
                    <div
                      v-if="form.choice_type == 'choice'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <div
                        v-for="(address, addrIndex) in form.answers"
                        :key="addrIndex"
                        class="flex flex-wrap items-center gap-3 py-2"
                      >
                        <label class="text-sm text-gray-700"
                          >Option {{ addrIndex + 1 }}:</label
                        >
                        <input
                          type="text"
                          v-model="address['answer_text']"
                          class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                          placeholder="Enter your option"
                          required
                        />
                        <input
                          type="checkbox"
                          v-model="address['is_correct']"
                          class="w-4 h-4"
                        />
                        <label class="text-sm">Is Answer</label>
                      </div>
                      <button
                        type="button"
                        @click="addMoreChoiceTypeUpdate(index)"
                        class="bg-blues text-sm text-white rounded-md px-4 py-2"
                      >
                        Add More
                      </button>
                    </div>

                    <!-- Short Description -->
                    <div
                      v-if="form.choice_type == 'shortdescription'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <input
                        type="number"
                        required
                        v-model="form.max_mark"
                        class="flex-1 border rounded-md p-2 text-sm"
                        placeholder="Add Mark"
                      />
                    </div>
                    <div
                      v-if="form.choice_type == 'coding'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <label
                        for="language"
                        class="text-sm font-semibold text-gray-700"
                      >
                        Select Programming Language:
                      </label>
                      <select
                        id="language"
                        v-model="form.programming_language"
                        class="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option disabled value="">Select Language</option>
                        <option value="python">Python</option>
                        <option value="java">Java</option>
                        <option value="cpp">C++</option>
                        <option value="c">C</option>
                        <option value="javascript">JavaScript</option>
                      </select>
                    </div>
                    <!-- Description -->
                    <div
                      v-if="form.choice_type == 'description'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <input
                        type="number"
                        required
                        v-model="form.max_mark"
                        placeholder="Add Mark"
                        class="flex-1 border rounded-md p-2 text-sm"
                      />
                    </div>

                    <!-- Match the Following -->
                    <div
                      v-if="form.choice_type == 'matchthefollowing'"
                      class="py-3 grid grid-cols-2 gap-2 mt-1 px-6"
                    >
                      <div>
                        <div
                          v-for="(address, addrIndex) in form.matchthefollowing"
                          :key="addrIndex"
                          class="flex flex-wrap items-center gap-3 py-2"
                        >
                          <input
                            type="text"
                            v-model="address.left_text"
                            class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                            placeholder="Enter Left Option"
                            required
                          />
                        </div>
                      </div>
                      <div>
                        <div
                          v-for="(address, addrIndex) in form.matchthefollowing"
                          :key="addrIndex"
                          class="flex flex-wrap items-center gap-3 py-2"
                        >
                          <input
                            type="text"
                            v-model="address.right_text"
                            class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                            placeholder="Enter Right Option"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <!-- True/False -->
                    <div
                      v-if="form.choice_type == 'truefalse'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <div
                        v-for="(address, addrIndex) in form.truefalse"
                        :key="addrIndex"
                        class="flex flex-wrap items-center gap-3 py-2"
                      >
                        <input
                          type="checkbox"
                          v-model="address['is_correct']"
                          class="w-4 h-4"
                        />
                        <label class="text-sm">
                          <span v-if="addrIndex == 0">True</span>
                          <span v-else>False</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>

              <div class="flex justify-end gap-4 mt-4">
                <button
                  type="button"
                  @click="addFormUpdateNew"
                  class="bg-blues text-sm text-white rounded-md px-4 py-2"
                >
                  Add Question
                </button>
              </div>

              <div class="flex justify-end mt-4">
                <button
                  type="submit"
                  class="text-white bg-blues rounded-lg text-xs px-6 py-2"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="flex flex-col w-full" v-if="this.is_selected == 'score'">
          <div class="px-3 lg:px-10 mt-10 pb-2">
            <button
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
              @click="this.is_selected = 'list'"
            >
              Back
            </button>
          </div>

          <div class="p-3 lg:p-10">
            <div
              class="bg-[#F9FAFC] py-4 px-8 flex flex-col md:flex-row items-center justify-between rounded-xl"
            >
              <div class="">
                <p class="text-lg text-blues font-semibold">Scoreboard</p>
              </div>

              <!-- {{ scoredetails }} -->
              <div class="flex gap-5">
                <div class="relative">
                  <span class="absolute inset-y-0 left-3 flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-4.35-4.35m0 0A7 7 0 103.65 3.65a7 7 0 0012.99 12.99z"
                      />
                    </svg>
                  </span>

                  <input
                    @input="quizgetscoreinfo(current_coursename)"
                    type="search"
                    v-model="searchValue"
                    placeholder="Search..."
                    class="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                  />
                </div>

                <div
                  @click="quizget(current_coursename)"
                  class="bg-blues text-white rounded-lg py-1.5 px-5 flex items-center gap-2 cursor-pointer"
                >
                  <img src="@/assets/newd/download1.png" alt="" />
                  <p class="text-sm text-white">Download</p>
                </div>
              </div>
            </div>
          </div>

          <div class="lg:px-3 px-10 pb-10">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-10">
              <!-- <pre>{{ updateDetails }}</pre> -->
              <div
                class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
              >
                <p class="font-bold text-center text-[#333333]">
                  Learners visited
                </p>
                <p class="text-xl font-bold text-blues">
                  {{ updateDetails.count }}
                </p>
              </div>
              <div
                class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
              >
                <p class="font-bold text-center text-[#333333]">
                  Learners appeared
                </p>
                <p class="text-xl font-bold text-blues">
                  {{ updateDetails.completed_count }}
                </p>
              </div>
              <div
                class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
              >
                <p class="font-bold text-center text-[#333333]">
                  Learners not attended
                </p>
                <p class="text-xl font-bold text-blues">
                  {{ updateDetails.not_completed_count }}
                </p>
              </div>
            </div>
          </div>

          <div class="lg:px-10 lg:rounded-3xl overflow-x-auto">
            <table class="table-auto w-full lg:rounded-3xl">
              <thead>
                <tr>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC] whitespace-nowrap"
                  >
                    S NO
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Email
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Learner
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Score
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Status
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Date
                  </th>
                  <th class="p-4 border-b text-center text-blues bg-[#F9FAFC]">
                    Validate
                  </th>
                </tr>
              </thead>
              <tbody v-if="scoredetails.data">
                <!-- <pre>{{ scoredetails.data }}</pre> -->
                <tr v-for="(el, index) in scoredetails.data" :key="el.id">
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">
                      {{ (currentPage - 1) * 10 + index + 1 }}
                    </p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ el.user?.email }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">
                      {{ el.user?.display_name }}
                    </p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p v-if="el.score" class="text-primary">{{ el.score }}</p>
                    <p v-else>-</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p
                      v-if="el.completed"
                      class="text-center text-gray-900 whitespace-no-wrap"
                    >
                      Completed
                    </p>
                    <p
                      v-else
                      class="text-center text-gray-900 whitespace-no-wrap"
                    >
                      Not Attended
                    </p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p v-if="el.finished_at != null">
                      {{ formatDateTime(el.finished_at) }}
                    </p>
                    <p v-else>-</p>
                  </td>

                  <td class="p-4 border-b text-center">
                    <div class="flex items-center justify-center">
                      <router-link
                        v-if="el.completed && el.quiz?.id"
                        :to="{
                          name: 'QuizVaildate',
                          params: {
                            course_id: this.course_id,
                            quiz_id: el.quiz.id,
                            taker_id: el.id,
                          },
                        }"
                        class="bg-blues text-white rounded-lg py-1.5 px-5 flex items-center gap-2 cursor-pointer"
                      >
                        <p class="text-sm text-white">Validate</p>
                      </router-link>
                      <p
                        v-else
                        class="text-center text-gray-900 whitespace-no-wrap"
                      >
                        Not Attended
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination
              :totalPages="totalPages"
              ref="paginationRef"
              @page-changed="quizgetscoreinfo(current_coursename, $event)"
            />
          </div>
        </div>

        <div class="flex flex-col w-full" v-if="this.is_selected == 'feedback'">
          <div class="px-3 lg:px-10 mt-10 pb-2">
            <button
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
              @click="this.is_selected = 'list'"
            >
              Back
            </button>
          </div>

          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>

          <div class="p-3 lg:p-10">
            <div
              class="bg-[#F9FAFC] py-4 px-8 flex flex-col md:flex-row items-center justify-between rounded-xl"
            >
              <div
                class="flex flex-col gap-2 md:flex-row flex-wrap items-center justify-between w-full"
              >
                <p class="text-lg text-blues font-semibold">Feedback</p>
                <div
                  class="flex flex-col md:flex-row flex-wrap gap-5 mt-2 md:mt-0"
                >
                  <div class="w-full md:w-48">
                    <select
                      ref="selectedRating"
                      v-model="selectedRating"
                      @change="this.getfeedback(this.current_coursename)"
                      class="w-full p-1.5 border border-gray-300 rounded-2xl bg-white"
                      :class="{ 'text-yellow-500': selectedRating }"
                    >
                      <option disabled value="">Rating...</option>
                      <option
                        v-for="i in 5"
                        :key="i"
                        :value="i"
                        class="w-5 h-5"
                      >
                        {{ "⭐".repeat(i) + "☆".repeat(5 - i) }}
                      </option>
                    </select>
                  </div>
                  <div class="flex flex-wrap gap-2">
                    <div class="w-full">
                      <select
                        ref="selectFilter"
                        name="model_select"
                        id="model_select"
                        v-model="selected_filter"
                        @change="this.getfeedback(this.current_coursename)"
                        class="px-4 py-2 w-full md:w-[160px] cursor-pointer rounded-full text-sm text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                      >
                        <option value="" disabled selected>
                          Select sorting
                        </option>
                        <option value="text">A to Z</option>
                        <option value="-text">Z to A</option>
                      </select>
                    </div>
                  </div>
                  <div class="relative max-w-64">
                    <form
                      @submit.prevent="
                        this.getfeedback(this.current_coursename)
                      "
                    >
                      <input
                        type="text"
                        placeholder="Search"
                        id="search"
                        v-model="searching"
                        @input="this.getfeedback(this.current_coursename)"
                        class="w-full pl-4 pr-10 py-1 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                      />
                      <button type="submit" class="">
                        <div
                          class="absolute right-3 top-2.5 h-4 w-4 text-gray-400"
                        >
                          <img
                            src="@/assets/search_icon1.svg"
                            alt=""
                            srcset=""
                          />
                        </div>
                      </button>
                    </form>
                  </div>
                  <div>
                    <button
                      @click="clearFilters"
                      class="ml-2 px-3 py-1 bg-blues text-white hover:bg-blue-600 rounded-2xl"
                    >
                      Clear
                    </button>
                  </div>

                  <div
                    @click="fetchdownload()"
                    class="bg-blues text-white rounded-2xl py-1 px-5 flex items-center gap-2 cursor-pointer"
                  >
                    <img src="@/assets/newd/download1.png" alt="" />
                    <p class="text-sm text-white">Download</p>
                  </div>
                </div>
              </div>

              <!-- {{ scoredetails }} -->
              <!-- <div @click="quizget(current_coursename)"
                class="bg-blues text-white rounded-lg py-1.5 px-5 flex items-center gap-2 cursor-pointer">
                <img src="@/assets/newd/download1.png" alt="" />
                <p class="text-sm text-white">Download</p>
              </div> -->
            </div>
          </div>

          <div class="lg:px-3 px-10 pb-10">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-10">
              <div
                class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
              >
                <p class="font-bold text-center text-[#333333]">Quiz Title</p>
                <p class="text-xl font-bold text-blues">
                  {{ feedback_list.quiz_title }}
                </p>
              </div>
              <div
                class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
              >
                <p class="font-bold text-center text-[#333333]">
                  Total Ratings
                </p>
                <p class="text-xl font-bold text-blues">
                  {{ feedback_list.feedback_count }}
                </p>
              </div>
              <div
                class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
              >
                <p class="font-bold text-center text-[#333333]">
                  Avarage Ratings
                </p>
                <!-- <p class="text-xl font-bold text-blues">
                  {{ feedback_list.average_rating }}
                </p> -->

                <div class="text-sm font-bold text-blues">
                  <div class="flex gap-2 items-center flex-wrap justify-center">
                    <div class="flex justify-center gap-1">
                      <template v-for="i in 5" :key="i">
                        <svg
                          :class="[
                            'w-6 h-6 transition',
                            i <= feedback_list.average_rating
                              ? 'text-yellow-400'
                              : 'text-gray-300',
                          ]"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                          />
                        </svg>
                      </template>
                    </div>
                    <p>{{ feedback_list.average_rating }} Out of 5</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="lg:px-10 lg:rounded-3xl overflow-x-auto">
            <table class="table-auto w-full lg:rounded-3xl">
              <thead>
                <tr>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC] whitespace-nowrap"
                  >
                    S NO
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Name
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Email
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Text
                  </th>
                  <th
                    class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                  >
                    Rating
                  </th>
                </tr>
              </thead>
              <tbody
                v-if="feedback_list.feedbacks && feedback_list.feedbacks.length"
              >
                <tr v-for="(el, index) in feedback_list.feedbacks" :key="el">
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ index + 1 }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ el.user_name }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ el.user_email }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ el.text }}</p>
                    <!-- <p v-else>-</p> -->
                  </td>
                  <td class="p-4 border-b border-r text-center">
                    <div class="flex justify-center gap-1">
                      <template v-for="i in 5" :key="i">
                        <svg
                          :class="[
                            'w-6 h-6 transition',
                            i <= el.rating
                              ? 'text-yellow-400'
                              : 'text-gray-300',
                          ]"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                          />
                        </svg>
                      </template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- <div class="lg:px-10 lg:rounded-3xl overflow-x-auto">
            <table class="table-auto w-full lg:rounded-3xl">
              <thead>
                <tr>
                  <th class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC] whitespace-nowrap">
                    S NO
                  </th>
                  <th class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]">
                    Email
                  </th>
                  <th class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]">
                    Learner
                  </th>
                  <th class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]">
                    Score
                  </th>
                  <th class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]">
                    Status
                  </th>
                  <th class="p-4 border-b text-center text-blues bg-[#F9FAFC]">
                    Validate
                  </th>
                </tr>
              </thead>
              <tbody v-if="scoredetails.data">
                <tr v-for="(el, index) in scoredetails.data" :key="el">
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ index + 1 }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ el.user.email }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p class="text-primary">{{ el.user.display_name }}</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p v-if="el.score" class="text-primary">{{ el.score }}</p>
                    <p v-else>-</p>
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    <p v-if="el.completed" class="text-center text-gray-900 whitespace-no-wrap">
                      Completed
                    </p>
                    <p v-else class="text-center text-gray-900 whitespace-no-wrap">
                      Not Attended
                    </p>
                  </td>

                  <td class="p-4 border-b text-center">
                    <div class="flex items-center justify-center">
                      <router-link v-if="el.completed" :to="{
                        name: 'QuizVaildate',
                        params: {
                          course_id: this.course_id,
                          quiz_id: el.quiz.id,
                          taker_id: el.id,
                        },
                      }" class="bg-blues text-white rounded-lg py-1.5 px-5 flex items-center gap-2 cursor-pointer">
                        <p class="text-sm text-white">Validate</p>
                      </router-link>
                      <p v-else class="text-center text-gray-900 whitespace-no-wrap">
                        Not Attended
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </div>
      <!-- add assesment form  -->
      <div
        v-if="this.addQuiz"
        @click.self="this.addQuiz = false"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
      >
        <div
          class="lg:w-[40%] w-[90%] bg-white rounded-xl p-5 md:p-10 overflow-y-auto max-h-[600px]"
        >
          <div class="flex items-center justify-center">
            <h3 class="text-xl font-bold text-blues text-center">
              Add Assessment
            </h3>
            <!-- <img
              src="@/assets/newd/close.png"
              class="cursor-pointer"
              alt=""
              @click="this.assignmentPopup = false"
            /> -->
          </div>

          <div
            class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
          >
            <div class="w-full">
              <form
                ref="quizAddReff"
                @submit.prevent="QuizPost"
                class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
              >
                <div class="flex flex-col gap-3 w-full">
                  <div class="flex justify-between">
                    <label
                      for="attachments"
                      class="text-left flex items-center whitespace-nowrap"
                      >Attachments *
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Only xls files in the sample format are allowed.
                        </div>
                      </div>
                    </label>
                    <div
                      class="md:w-[20%] flex justify-center items-center whitespace-nowrap"
                    >
                      <a
                        href="https://alliance-lms.s3.ap-south-1.amazonaws.com/media/uploaded_videos/quiz_questions_Y1XzIps.xls"
                        download
                        class="w-full flex gap-1 items-center justify-center tooltip"
                      >
                        <img
                          src="@/assets/newd/download.png"
                          alt="download file"
                          class="w-4 h-4 object-contain"
                        />
                        <span class="tooltiptext text-xs w-full">
                          Sample File</span
                        >
                      </a>
                    </div>
                  </div>
                  <input
                    id="source"
                    type="file"
                    class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                    required
                  />
                </div>
                <div class="flex justify-center pb-4 mt-3 gap-10">
                  <button
                    @click="this.addQuiz = false"
                    class="border text-gray-500 border-[#0085db] hover:border-[#18469d] hover:bg-[#18469d] cursor-pointer hover:text-white rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                  >
                    Close
                  </button>
                  <div class="flex items-center gap-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Upload
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="popUpQuiz"
        @click.self="popUpQuiz = false"
        class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center px-6 md:px-0"
      >
        <div
          class="w-full md:w-[80%] lg:w-[60%] bg-white rounded-xl p-3 md:p-10 overflow-y-auto"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4">
              <h3
                class="text-base font-bold px-4 py-1 rounded-xl cursor-pointer text-blues"
              >
                Edit
              </h3>
            </div>
            <img
              src="@/assets/newd/close.png"
              class="cursor-pointer w-5 h-5"
              alt="Close"
              @click="popUpQuiz = false"
            />
          </div>

          <div
            class="w-full mt-4 flex flex-col md:p-6 relative border border-gray-100 rounded-2xl"
          >
            <form
              ref="addQuizRefs"
              @submit.prevent="editQuizContent(quizdetailsget.id)"
              class="w-full flex flex-col gap-3"
            >
              <div class="flex flex-col gap-3 w-full">
                <label for="title" class="text-sm font-medium">
                  Title <span class="text-red-400">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  v-model="quizdetailsget.name"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>

              <div class="flex flex-col gap-3 w-full">
                <label for="content" class="text-sm font-medium">
                  Description <span class="text-red-400">*</span>
                </label>
                <textarea
                  id="content"
                  type="text"
                  v-model="quizdetailsget.description"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                ></textarea>
              </div>

              <!-- lesson_or_quiz -->

              <div class="flex flex-row gap-4">
                <input
                  id="question_attempt"
                  type="checkbox"
                  v-model="quizdetailsget.question_attempt"
                />
                <label for="question_attempt" class="text-sm font-medium">
                  Multiple Attempt
                </label>
              </div>
              <div
                class="flex flex-row gap-4"
                v-if="quizdetailsget.lesson_quize == false"
              >
                <input
                  id="question_shuffle"
                  type="checkbox"
                  v-model="quizdetailsget.shuffle"
                />
                <label for="question_shuffle" class="text-sm font-medium">
                  Shuffle
                </label>
              </div>
              <div
                class="flex flex-col gap-2"
                v-if="quizdetailsget.lesson_quize == false"
              >
                <div class="flex items-center gap-3">
                  <label
                    for="maxquestion"
                    class="text-sm font-medium w-[130px]"
                  >
                    Max questions
                  </label>

                  <input
                    id="maxquestion"
                    type="number"
                    v-model.number="quizdetailsget.max_questions"
                     @input="handleMaxQuestionInput"
                    class="px-3 py-2 w-[120px] text-sm border rounded-lg outline-none"
                    :class="{
                      'border-gray-300 focus:ring-2 focus:ring-blues focus:border-blues':
                        !maxQuestionError,
                      'border-red-500 focus:ring-2 focus:ring-red-400 focus:border-red-500':
                        maxQuestionError,
                    }"
                    min="1"
                  />
                  <p class="text-2xl h-10 flex items-center">
                    / {{ quizdetailsget.questions.length || 0 }}
                  </p>
                </div>

                <p
                  v-if="maxQuestionError"
                  class="text-red-500 text-xs pl-[130px]"
                >
                  Max questions cannot be more than
                  {{ quizdetailsget.questions.length }}.
                </p>
              </div>

              <div
                class="flex flex-col gap-3 w-full"
                v-if="quizdetailsget.question_attempt"
              >
                <label for="question_attempt_count" class="text-sm font-medium">
                  Attempt Count <span class="text-red-400">*</span>
                </label>
                <input
                  id="question_attempt_count"
                  type="number"
                  v-model="quizdetailsget.question_attempt_count"
                  required
                  class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
                />
              </div>

              <!-- <div class="flex flex-col gap-3 w-full">
              <label for="order" class="text-sm font-medium">
                Order By <span class="text-red-400">*</span>
              </label>
              <input
                id="order"
                type="number"
                v-model="quizdetailsget.order"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3 border outline-none"
              />
            </div> -->
              <div class="flex justify-end gap-4 mt-4">
                <div class="flex items-center gap-3">
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                    "
                    class="rounded-lg text-sm px-4 py-2"
                  >
                    Save
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <ServerError v-if="server_error" @close="closeError" />
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import ServerError from "@/components/ServerError.vue";
import { VueDraggableNext } from "vue-draggable-next";
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    SideBar,
    ConfirmPopup,
    FlashMessage,
    ServerError,
    draggable: VueDraggableNext,
    Pagination,
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
      updateDetails: "",
      not_attended: 0,
      current_coursename: "",
      scoredetails: "",
      published: "",
      popupwindow: false,
      titlepass: "",
      is_selected: "list",
      quiz_id: 0,
      generalquiz: [],
      messages: {
        text: "",
        type: "null",
      },
      addQuiz: false,
      loading: true,
      quizdetailsget: [],
      popUpAction: null,
      typeQuiz: "course",
      editQuizId: null,
      active_tab: "Course Quiz",
      server_error: false,
      popupwindowquestiondelete: null,
      disable_submit: false,
      editAttempt: null,
      popUpQuiz: false,
      feedback_list: [],
      searching: "",
      selected_filter: "",
      selectedRating: "",
      response_message: "",
      searchValue: "",
    };
  },

  created() {
    this.quizgetinfo();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
    maxQuestionError() {
      return (
        this.quizdetailsget.max_questions > this.quizdetailsget.questions.length
      );
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
     handleMaxQuestionInput(e) {
    const val = e.target.value;

    if (val === "" || val === null) {
      this.quizdetailsget.max_questions = null;
      return;
    }

    this.quizdetailsget.max_questions = Number(val);
  },

  maxQuestionError() {
    return (
      this.quizdetailsget.max_questions !== null &&
      this.quizdetailsget.max_questions > this.quizdetailsget.questions.length
    );
  },
    formatDateTime(date) {
      const d = new Date(date);

      const formattedDate = d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      const formattedTime = d
        .toLocaleTimeString("en-IN", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })
        .toLowerCase(); // makes "PM" → "pm"

      return `${formattedDate} - ${formattedTime}`;
    },
    async handleQuizOrderChange() {
      const token_key = this.userInfo.token_key;
      const quizzes = this.generalquiz || [];

      quizzes.forEach((quiz, index) => {
        quiz.order = index + 1;
      });

      for (let quiz of quizzes) {
        const quizId = quiz.quiz?.id;
        if (!quizId) continue;
        console.log("----", this.quizId);
        const orderData = {
          name: quiz.quiz?.name,
          qualify_certificate: quiz.quiz?.qualify_certificate || false,
          order: quiz.order,
        };

        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/coursequizpublished/${quizId}/?Key=${token_key}`,
            orderData
          );
        } catch (error) {
          this.messages = {
            text: "Failed to update quiz order",
            type: "error",
          };
          return;
        }
      }

      this.messages = {
        text: "Quiz order updated successfully",
        type: "success",
      };

      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },

    addMoreChoiceTypeUpdate(index) {
      this.quizdetailsget.questions[index].answers.push({
        answer_text: "",
        is_correct: false,
      });
    },
    async onReorder(evt) {
      const token_key = this.userInfo.token_key;
      const questions = this.quizdetailsget.questions || [];
      questions.forEach((question, index) => {
        question.order = index + 1;
      });

      for (let question of questions) {
        if (!question.id) continue;

        const infoDetails = {
          order: question.order,
        };

        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/coursequiz/question/${question.id}/?Key=${token_key}`,
            infoDetails
          );
          console.log("Reorder updated:", response.data);
        } catch (err) {
          console.error("Order update error:", err);
          this.messages = {
            text: "Failed to update question order",
            type: "error",
          };
          return;
        }
      }

      this.messages = {
        text: "Question order updated successfully",
        type: "success",
      };

      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },

    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.popUpAction = null;
      }
    },
    async getfeedback(id) {
      this.feedback_list = [];
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiz-feedback/summary/course/${this.course_id}/?quize__id=${id}&Key=${this.userInfo.token_key}&search=${this.searching}&ordering=${this.selected_filter}&rating=${this.selectedRating}`
        )
        .then((res) => {
          if (res.data.data.status === 200 && res.data.data.data.length > 0) {
            this.feedback_list = res.data.data.data[0];
            // console.log("this.feedback_list", this.feedback_list);
          }
        });
    },
    clearFilters() {
      this.selected_filter = "";
      this.selectedRating = "";
      this.searching = "";
      this.getfeedback(this.current_coursename);
    },

    async quizgetscoreinfofeedback(coursename) {
      this.is_selected = "feedback";
      this.current_coursename = coursename;
      console.log("quis id::", this.current_coursename);
      this.getfeedback(coursename);
      // console.log(
      //   `${process.env.VUE_APP_API}/coursequizattemptcount/${coursename}/?Key=${this.userInfo.token_key}`
      // );
      // await axios
      //   .get(
      //     `${process.env.VUE_APP_API}/coursequizattemptcount/${coursename}/?Key=${this.userInfo.token_key}`
      //   )
      //   .then((response) => {
      //     if (response.data.data) {
      //       this.scoredetails = response.data;
      //       console.log("this.generalquiz", this.scoredetails);
      //       // this.published = this.generalquiz[0].quiz.qualify_certificate
      //       // console.log("this.generalquiz::",this.generalquiz[0].quiz.qualify_certificate)
      //     }
      //     else{
      //       console.log("something went wrong.");
      //     }
      //   });
    },

    duplicateQuiz(id) {
      this.messages = {
        text: "Quiz Duplicating...",
        type: "success",
      };
      // this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequize/duplication/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          // this.loading = false;
          if (response) {
            // this.generalquiz = [];
            this.messages = {
              text: "Quiz Duplicated successfully",
              type: "success",
            };
            this.quizgetinfo();
            // this.popupwindow = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            // this.$router.go(0);
            this.popupwindowquestiondelete = null;
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        });
    },

    editQuizContent(id) {
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.quizgetinfo();
            this.popUpQuiz = false;
            this.messages = {
              text: "Quiz Details Updated Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },
    // popUpQuiz
    quizdetailsof_details(id) {
      // this.is_selected = "detail";
      // course_quizzes_detail
      this.popUpQuiz = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
          } else {
            // this.loading=false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addFormUpdateNew() {
      this.quizdetailsget.questions.push({
        question_text: "",
        choice_type: "choice",
        answers: [
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
        ],
        truefalse: [
          { answer_text: "True", is_correct: false },
          { answer_text: "False", is_correct: false },
        ],
        matchthefollowing: [
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
        ],
        shortAnswer: "",
        longAnswer: "",
        max_mark: 0,
        // shortAnswerMark: "",
        // longAnswerMark:"",
      });
    },

    removeFormUpdate(index) {
      this.quizdetailsget.questions.splice(index, 1);
      // if (this.forms.length > 1) {
      //   this.forms.splice(index, 1);
      // } else {
      //   alert("At least one form must be present!");
      // }
    },

    removeQuestion(id) {
      axios
        .delete(
          `${process.env.VUE_APP_API}/coursequiz/question/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response) {
            // this.generalquiz = [];
            this.messages = {
              text: "Quiz Deleted successfully",
              type: "success",
            };
            this.quizgetinfo();
            // this.popupwindow = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            // this.$router.go(0);
            this.popupwindowquestiondelete = null;
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        });
    },

    closeError() {
      this.server_error = false;
      location.reload();
    },

    PostDataAttempt(id) {
      this.disable_submit = true;
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.quizgetinfo();
            this.editAttempt = null;
            this.messages = {
              text: "Quiz Attempt Updated Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },
    editshuffleContent(id, status) {
      this.disable_submit = true;
      let messagesPass = {
        shuffle: status === false ? true : false,
      };
      axios
        .patch(
          `${process.env.VUE_APP_API}/coursequiz/title/update/${id}/?Key=${this.userInfo.token_key}`,
          messagesPass
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data) {
            this.quizgetinfo();
            this.editAttempt = null;
            this.messages = {
              text: "Shuffles Updated Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },

    PostData(id) {
      this.disable_submit = true;
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizgetinfo();
            this.editQuizId = null;
            this.messages = {
              text: "Quiz Name Updated Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },

    editId(id) {
      this.quizdetailsgetofnone(id);
      if (this.editQuizId == id) {
        this.editQuizId = null;
      } else {
        this.editQuizId = id;
      }
    },

    editIdAttempt(id) {
      // this.loading = true;
      this.quizdetailsgetofnone(id);
      if (this.editAttempt == id) {
        this.editAttempt = null;
      } else {
        this.editAttempt = id;
      }
    },

    addOperation(id) {
      if (this.popUpAction == id) {
        this.popUpAction = null;
      } else {
        this.popUpAction = id;
      }
    },

    quizdetailspreview(id) {
      this.is_selected = "preview";
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
          } else {
            // this.loading=false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateQuizOfSection(value_id) {
      this.disable_submit = true;
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${value_id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget
        )
        .then((response) => {
          if (response.data.status == "200") {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.is_selected = "detail";
              this.quizgetinfo();
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          } else {
            // console.log("something went wrong");
            // this.is_selected = 'detail';
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              // this.lessoninfoGet();
              // this.popUpupdateQuiz = false;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
    },

    quizdetails(id) {
      this.is_selected = "detail";
      // course_quizzes_detail
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
          } else {
            // this.loading=false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    quizdetailsgetofnone(id) {
      // course_quizzes_detail
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
            console.log(this.quizdetailsget);

            this.loading = false;
          } else {
            // this.loading=false;
            this.server_error = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.server_error = true;
        });
    },

    async QuizPost(el) {
      this.disable_submit = true;
      this.loading = true;
      var sourceFile;
      if (el.target.elements.source.files.length > 0) {
        sourceFile = el.target.elements.source.files[0];
      } else {
        sourceFile = "";
      }
      // console.log("this.course_id", this.course_id);

      let urls = `${process.env.VUE_APP_API}/excelcourse_question_answer_new/${this.course_id}/?Key=${this.userInfo.token_key}`;
      let HeaderVal = new FormData();

      // let couseId = this.courseId;

      HeaderVal.append("my_file", sourceFile);
      console.log("HeaderVal::", HeaderVal);

      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.loading = true;
          if (response.data.status == 200) {
            this.messages = {
              text: "Course Quiz added successfully",
              type: "success",
            };
            // this.$refs.lessonaddFn.reset();
            this.quizgetinfo();
            setTimeout(() => {
              this.popUpLesson = false;
              this.addQuiz = false;
            }, 3000);
          } else {
            this.messages = {
              text: "Event Failed",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
        (this.questionAnswer = []), (this.quizCourse = null);
        setTimeout(() => {
          // window.location.reload();
          // this.$refs.quizAddReff.reset();
        }, 200);
      }, 1500);

      // })
    },

    async quizgetinfo() {
      this.loading = true;
      this.is_selected = "list";
      this.generalquiz = [];
      if (this.typeQuiz == "course") {
        await axios
          .get(
            `${process.env.VUE_APP_API}/course_quizzes_detail/${this.course_id}/?Key=${this.userInfo.token_key}`
          )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.generalquiz = response.data.data;
              this.loading = false;
              this.published = this.generalquiz;
              console.log(this.published);
            } else if (response.data.status == 400) {
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
      }
      if (this.typeQuiz == "lesson") {
        await axios
          .get(
            `${process.env.VUE_APP_API}/lesson_quizzes_detail/${this.course_id}/?Key=${this.userInfo.token_key}`
          )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.generalquiz = response.data.data;
              this.loading = false;
              this.published = this.generalquiz;
              console.log(this.published);
            } else if (response.data.status == 400) {
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
      }
    },

    async quizget(course_name) {
      // console.log("dataaaaaaaaaaaaaaaa",`${process.env.VUE_APP_API}/coursequizdownloadattemptcount/${this.course_id}/${this.current_coursename}/?Key=${this.userInfo.token_key}`)
      await axios
        .get(
          `${process.env.VUE_APP_API}/coursequizdownloadattemptcount/${course_name}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            const link = document.createElement("a");
            link.href = `${process.env.VUE_APP_API}/coursequizdownloadattemptcount/${course_name}/?Key=${this.userInfo.token_key}`;
            link.setAttribute("download", "filetest.xlsx");
            document.body.appendChild(link);
            link.click();
          } else {
          }
          // const link = document.createElement("a");
          // link.href = `${process.env.VUE_APP_API}/coursequizdownloadattemptcount/${this.course_id}/${this.current_coursename}/?Key=${this.userInfo.token_key}`;
          // link.setAttribute("download", "filetest.xlsx");
          // document.body.appendChild(link);
          // link.click();
          // console.log("aftorlink::",link)
        });
    },

    async quiz_published(coursequizname, name, status) {
      this.disable_submit = true;
      this.published = status;
      let that = this;
      let messagesPass = {
        name: name,
        qualify_certificate: status,
      };
      await axios
        .put(
          `${process.env.VUE_APP_API}/coursequizpublished/${coursequizname}/?Key=${this.userInfo.token_key}`,
          messagesPass
        )
        .then((response) => {
          this.publishedquiz = response.data;
          if (response.data.status == 200) {
            this.quizgetinfo();
            if (that.published == true) {
              // this.generalquiz = []
              this.messages = {
                text: "course quiz published successfully",
                type: "success",
              };
            } else {
              // this.generalquiz = []
              this.messages = {
                text: "course quiz Unpublished successfully",
                type: "error",
              };
            }

            this.popupwindow = false;
          } else {
            this.messages = {
              text: "Quiz name, description, total score and min score filed check Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
      }, 1500);
    },

    async quizgetscoreinfo(coursename, page = 1) {
      this.currentPage = page;
      this.is_selected = "score";
      this.current_coursename = coursename;
      console.log("-----", coursename);
      // console.log(
      //   `${process.env.VUE_APP_API}/coursequizattemptcount/${coursename}/?Key=${this.userInfo.token_key}`
      // );
      await axios
        .get(
          `${process.env.VUE_APP_API}/coursequizattemptcount/${coursename}/?Key=${this.userInfo.token_key}&search=${this.searchValue}&page=${page}`
        )
        .then((response) => {
          if (response.data.data) {
            this.scoredetails = response.data.data;
            this.updateDetails = response.data;
            this.totalPages = response.data.data.total_page;
            console.log("this.generalquiz", this.scoredetails);
            // this.published = this.generalquiz[0].quiz.qualify_certificate
            // console.log("this.generalquiz::",this.generalquiz[0].quiz.qualify_certificate)
          } else {
            console.log("something went wrong.");
          }
        });
    },
    QuizDeleted(titlepass) {
      this.disable_submit = true;
      this.loading = true;
      // console.log(this.quizCourse)
      // let messagesPass = {
      //   name: titlepass,
      // };
      axios
        .delete(
          `${process.env.VUE_APP_API}/coursequizdeleted/${titlepass}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.generalquiz = [];
            this.messages = {
              text: "course Quiz Deleted successfully",
              type: "success",
            };
            this.popupwindow = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            this.$router.go(0);
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
    },

    async fetchdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/trigger-quiz-feedback-download/?course_id=${this.course_id}&quiz_id=${this.current_coursename}&Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp && resp.data.status == 200 && resp.data.download_link) {
            const link = document.createElement("a");
            link.href = resp.data.download_link;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
.ghost {
  opacity: 0.5;
}
.dragArea {
  max-height: 70vh;
  overflow-y: auto;
}

.chosen {
  cursor: grabbing;
}

.drag-handle {
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}
.drag-handle-quiz:active {
  cursor: grabbing;
}
.drag-handle-quiz {
  cursor: grab;
}
.ghost {
  border: 1px dashed gray;
  opacity: 0.5;
  background: #ffffff;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.flip-list {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}
</style>
